import Phaser from 'phaser';
import { SCENE_KEYS } from '../config';

export class BootScene extends Phaser.Scene {
  constructor() { super({ key: SCENE_KEYS.BOOT }); }
  preload(): void { this.scene.start(SCENE_KEYS.PRELOAD); }
}
